module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/web3/~/websocket/lib/version.js
// module id = 2004
// module chunks = 0 1 3